import { webapi, type WebapiEndpointBuilder } from '@/api/webapi.ts';

export const getOrderRequestedEmails = (builder: WebapiEndpointBuilder) => {
  return builder.query<string[], number>({
    query: (request) => ({
      url: `/oms/emails/${request}`,
      method: 'GET',
      headers: {
        // without this header, the response is a string
        // instead of JSON, even if the value is "application/json"
        //accept: '*/*',
      },
    }),
  });
};

export const emailsRequestedApi = webapi.injectEndpoints({
  endpoints: (builder) => ({
    getOrderRequestedEmails: getOrderRequestedEmails(builder),
  }),
});

export const { useGetOrderRequestedEmailsQuery } = emailsRequestedApi;
